/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_TitleInputs */

const cs_lustrace_history_title = /** @type {(inputs: Lustrace_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historie lustrace`)
};

const en_lustrace_history_title = /** @type {(inputs: Lustrace_History_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lustrace history`)
};

/**
* | output |
* | --- |
* | "Lustrace history" |
*
* @param {Lustrace_History_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_title = /** @type {((inputs?: Lustrace_History_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_title(inputs)
	return cs_lustrace_history_title(inputs)
});